import React, { useEffect, useState } from "react";
import { MapLeftPanel } from "../../shared/map-left-panel/map-left-panel";
import MasterCreateStudy from "../../components/features/master-create-study/master-create-study";
import styles from "./master-create-study-page.module.scss";
import { MapWrapper } from "../../shared/map-wrapper/map-wrapper";
import MapControls from "../../components/map-controls/map-controls";
import { MapSection, setSection } from "../../services/reducers/map";
import { initializeMap } from "../../services/actions/map";
import { useAppDispatch } from "../../hooks/useAppDispatch";

const MasterCreateStudyPage = () => {
  const [leftPanelOpened, setLeftPanelOpened] = useState<boolean>(true);
  const [panelWidth, setPanelWidth] = useState<number>(0);

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSection(MapSection.masterStudy));
    dispatch(initializeMap({ section: MapSection.masterStudy, mode: "2d" }));
    return () => {
      dispatch(initializeMap({ section: MapSection.none, mode: "2d" }));
    };
  }, []);

  return (
    <div className={styles.masterCreateStudyPage}>
      <MapLeftPanel
        isExtendedWidth={true}
        onWidthChange={setPanelWidth}
        leftPanelOpened={leftPanelOpened}
        closeLeftPanel={setLeftPanelOpened}
      >
        <MasterCreateStudy />
      </MapLeftPanel>
      <MapWrapper
        leftPanelOpened={leftPanelOpened}
        panelWidth={panelWidth}
        containerId={`${MapSection.masterStudy}MapContainer`}
      />
      <MapControls />
    </div>
  );
};

export default MasterCreateStudyPage;
